import { Button, Col, DatePicker, Form, Input, Row, Switch } from 'antd';
import Title from 'antd/es/typography/Title';
import { APP_LOCAL_DATE_FORMAT, APP_LOCAL_DATE_FORMAT_PAYLOAD } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import dayjs from 'dayjs';
import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Container } from 'reactstrap';
import { createEntity, getEntity, updateEntity } from '../report-schedule.reducer';

export const ReportScheduleUpdate = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { reportScheduleType } = location.state || {};
  const [form] = Form.useForm();
  const { id } = useParams();
  const isNew = id === undefined;

  const reportScheduleEntity = useAppSelector(state => state.reportSchedule.entity);
  const updating = useAppSelector(state => state.reportSchedule.updating);
  const updateSuccess = useAppSelector(state => state.reportSchedule.updateSuccess);

  const handleClose = () => {
    form.resetFields();
    navigate('/report-schedule');
  };

  useEffect(() => {
    innitData();
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  useEffect(() => {
    if (reportScheduleEntity && !isNew) {
      form.setFieldsValue({
        ...reportScheduleEntity,
        startDate: dayjs(reportScheduleEntity.startDate),
        endDate: dayjs(reportScheduleEntity.endDate),
        reportDate: dayjs(reportScheduleEntity.reportDate),
      });
    }
  }, [reportScheduleEntity]);

  const innitData = () => {
    // get detail
    if (isNew) {
      form.resetFields();
    } else {
      dispatch(getEntity(id));
    }
  };

  const handleSubmit = values => {
    const type = !isNew ? reportScheduleEntity?.reportScheduleType : reportScheduleType;
    const entity = {
      ...reportScheduleEntity,
      ...values,
      reportScheduleType: type,
      reportDate: dayjs(values.reportDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
      startDate: dayjs(values.startDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
      endDate: dayjs(values.endDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
    };
    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  return (
    <Container className="form">
      <Form size="large" form={form} initialValues={{ isEnabled: true }} onFinish={handleSubmit} layout="vertical">
        <Title level={3}>{`${id ? 'Cập nhật thông tin' : 'Thêm mới'} kỳ báo cáo`}</Title>
        <Row>
          <Col md={11}>
            <Form.Item label="Tên kỳ báo cáo" rules={[{ required: true, message: 'Hãy nhập tên kỳ báo cáo' }]} name="name">
              <Input className="w-100" size="large" placeholder="Nhập tên kỳ báo cáo" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={12}>
            <Form.Item label="Thời hạn báo cáo" rules={[{ required: true, message: 'Hãy chọn thời hạn báo cáo' }]} name="reportDate">
              <DatePicker className="w-100" format={APP_LOCAL_DATE_FORMAT} placeholder="Chọn thời hạn báo cáo" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item label="Ngày bắt đầu" rules={[{ required: true, message: 'Hãy chọn ngày bắt đầu' }]} name="startDate">
              <DatePicker className="w-100" format={APP_LOCAL_DATE_FORMAT} placeholder="Chọn ngày bắt đầu" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={12}>
            <Form.Item label="Ngày kết thúc" rules={[{ required: true, message: 'Hãy chọn ngày kết thúc' }]} name="endDate">
              <DatePicker className="w-100" format={APP_LOCAL_DATE_FORMAT} placeholder="Chọn ngày kết thúc" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col md={24}>
            <Form.Item label="Tình trạng" name={'isEnable'}>
              <Switch checkedChildren="Mở" unCheckedChildren="Đóng" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Row className="action mt-3" justify="end">
            <Col>
              <Button
                className="secondary"
                onClick={() => {
                  handleClose();
                }}
              >
                Hủy
              </Button>
            </Col>
            <Col>
              <Button className="primary" htmlType="submit" disabled={updating}>
                Lưu
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Container>
  );
};

export default ReportScheduleUpdate;
